import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['submitButton', 'submitText', 'loadingText']

  submit() {
    this.submitButtonTarget.disabled = true
    this.submitButtonTarget.classList.add('opacity-75', 'cursor-not-allowed')

    if (this.hasSubmitTextTarget) {
      this.submitTextTarget.classList.add('hidden')
    }
    if (this.hasLoadingTextTarget) {
      this.loadingTextTarget.classList.remove('hidden')
    }

    this.startDotsAnimation()
  }

  startDotsAnimation() {
    if (!this.hasLoadingTextTarget) return

    const baseText = this.loadingTextTarget.dataset.baseText || 'Carregando'
    this.loadingTextTarget.innerHTML = `${baseText}<span class="inline-block w-[1em] text-left"></span>`
    this.dotCount = 0

    this.dotsInterval = setInterval(() => {
      this.dotCount = (this.dotCount % 3) + 1
      const dots = '.'.repeat(this.dotCount)
      this.loadingTextTarget.innerHTML = `${baseText}<span class="inline-block w-[1em] text-left">${dots}</span>`
    }, 400)
  }

  disconnect() {
    if (this.dotsInterval) {
      clearInterval(this.dotsInterval)
    }
  }
}
